import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-list-kenworth",
  "use": "icon-ic-list-kenworth-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-ic-list-kenworth\"><path d=\"M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12A12 12 0 0 0 12 0zm0 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zM11 8h-.31l2.15 3H15l-2.78-3.69L14.77 4H12.7l-2 3h.3V4H9v7h2V8zm2.65 9-1.36-5h-1.58l-1.46 5L8 12H6l2.13 7h2l1.36-4 1.2 4h2L17 12h-2l-1.35 5z\" fill=\"#323336\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol